export default {
  languageSurvey: state => state.language,

  value: state => state.value || window.sessionStorage.getItem('value'),

  page: state => state.page,

  isVisitorAccess: state => state.isVisitorAccess,

  user: state => state.user || JSON.parse(window.sessionStorage.getItem('user')) || {},

  messages: state =>
    Object.prototype.toString.call(state.messages) === '[object String]'
      ? state.messages
      : state.messages.message,

  modalProperties: state => state.modalProperties,

  modalClone: state => state.modalClone,

  isSurveyAdvancedSettingsModalOpen: state => state.toggleSurveyAdvancedSettingsModal,

  modalBtns: state => state.modalBtns,

  modalGroupsAdvancedSettings: state => state.modalGroupsAdvancedSettings,

  modalPreview: state => state.modalPreview,

  modalMedia: state => state.modalMedia,

  modalTemplate: state => state.modalTemplate,

  mediaObj: state => state.mediaObj,

  deleteMedia: state => state.deleteMedia,

  modalFacialCoding: state => state.modalFacialCoding,

  facialCodingObj: state => state.facialCodingObj,

  token: state => state.token || window.sessionStorage.getItem('token'),

  username: state => state.username || window.sessionStorage.getItem('username'),

  darkmode: state => state.darkmode,

  tabBilling: state =>
    state.tabBilling || JSON.parse(window.sessionStorage.getItem('tabBilling')),

  accType: state => state.accType || window.sessionStorage.getItem('accType'),

  rateCard: state => state.rateCard || window.sessionStorage.getItem('rateCard'),

  groupName: state => state.groupName || window.sessionStorage.getItem('groupName'),

  changeFlow: state =>
    state.changeFlow || JSON.parse(window.sessionStorage.getItem('changeFlow')),

  firstAccess: state =>
    state.firstAccess || JSON.parse(window.sessionStorage.getItem('firstAccess')),

  isLogged: state => {
    return function() {
      return state.token || window.sessionStorage.getItem('token')
    }
  },

  loginModal: state => state.loginModal,

  users: state => state.users,

  hasSurvey: state => {
    return function() {
      return state.hasSurvey || window.sessionStorage.getItem('hasSurvey') === 'true'
    }
  },

  hasProjectCreated: state => {
    return state.projectCreated
  },

  isLoadingSaveSettingsQuota: state => {
    return state.loadingSaveSettingsQuota
  },

  isLoading: state => {
    return state.loading
  },

  questionGroups: state => {
    return state.questionGroups
  },

  chartType: state => {
    return state.chartType
  },

  chartSettings: state => {
    return state.chartSettings
  },

  showConfig: state => {
    return state.showConfig
  },
  questionCodeValidation: state => {
    return state.questionCodeValidation
  },

  reportQuestionsDownloadControl: state => {
    return state.reportQuestionsDownloadControl
  },

  survey: state => {
    return {
      ...(state.survey || JSON.parse(window.sessionStorage.getItem('survey'))),

      questions_groups: state.questionGroups.length
        ? state.questionGroups
        : JSON.parse(window.sessionStorage.getItem('surveyQuestionsGroups')),
    }
  },

  surveyStatusWithChartConfig: state => {
    return state.surveyStatusWithChartConfig
  },
}
